var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/uncheck.c4714448.png","uri@2x": __webpack_public_path__ + "static/media/uncheck.c3f64c32.png","uri@3x": __webpack_public_path__ + "static/media/uncheck.ebc67fae.png",
    width: 18,
    height: 18
});